import TOOLS from '@helpers/tools'
import FILTERS from '@helpers/filters'

export default function apartmentsDataLayerBody(stateId, locations, imoveis, path, type) {
  let stateData = TOOLS.getCityState(locations, stateId)
  if (typeof window !== 'undefined') {
    window.dataLayer.push({ imoveis: undefined })
    window.dataLayer.push({
      event: 'dados-imoveis',
      pagepath: path,
      pageType: type,
      estado: TOOLS.slugify(stateData.filtroCidade[0].nomeCidade),
      cidade: TOOLS.slugify(stateData.nome),
      imoveis: imoveis.map((h, index) => {
        return {
          id: h.ImovelId,
          nome: TOOLS.slugify(h.Nome),
          bairro: TOOLS.slugify(h.Endereco.Bairro),
          cidade: TOOLS.slugify(h.Endereco.Cidade),
          estado: TOOLS.slugify(h.Endereco.Estado),
          areaprivativa: h.AreaPrivativaM2 ? TOOLS.slugify(h.AreaPrivativaM2) : undefined,
          dormitorios: TOOLS.slugify(h.Quartos),
          vagas: h.VagasGaragem,
          valor: h.PrecoMinimo ? FILTERS.moneyBi(h.PrecoMinimo) : undefined,
          status: h.Status ? TOOLS.slugify(h.Status) : undefined,
          position: index,
        }
      }),
    })
  }
}



// WEBPACK FOOTER //
// ./src/helpers/BI/apartmentsDataLayer.js